// Changing paint output must invalidate both browser URLs and server bake caches.
export const PAINT_RENDER_VERSION = "7.1";
